/**
 * Canonical aspect-value colour — the ONE string→colour function.
 *
 * A stable hash from a string value → a named palette swatch, so the same value
 * always paints the same colour across reloads, diagrams, AND surfaces. Pure +
 * deterministic. (Deliberately no list of callers here: this is the bottom of
 * the stack, and an enumeration of who calls it goes stale the moment one more
 * surface does.)
 *
 * It IS `colorize()`: the same `swatchFor` the engine's cast uses, then
 * `paletteColor` for the theme's pixels. So an aspect-coloured board, a
 * `style * { color: colorize(@@team) }` view, and an export can never disagree
 * about what colour a team is.
 */
import { swatchFor } from "@archlang/engine";
import { paletteColor, type PaletteTheme } from "@archlang/scene";

/** Stable colour for an aspect value, as a concrete CSS colour. */
export function aspectColorFor(value: string, theme?: PaletteTheme): string {
  return paletteColor(swatchFor(value), theme);
}
